import { defineStore } from 'pinia';
import { useFetch } from '../../../composables/useFetch';
import { INewsArticle } from '../model/news-overview.model';

interface INewsOverviewState {
    articles: INewsArticle[];
    page: number;
    pageSize: number;
    totalPages: number;
    totalResults: number;
    error: string | null | unknown;
    loading: boolean;
}

export const useNewsOverviewStore = defineStore('newsOverviewStore', {
    state: (): INewsOverviewState => {
        return {
            articles: [],
            error: null,
            loading: false,
            page: 0,
            pageSize: 0,
            totalPages: 0,
            totalResults: 0,
        };
    },
    getters: {
        getArticles(state) {
            return state.articles;
        },
    },
    actions: {
        async getData(url: string) {
            try {
                const { data, error, isLoading } = await useFetch(url);

                if (data.value) {
                    this.articles = data.value.items;
                    this.page = data.value.page;
                    this.pageSize = data.value.pageSize;
                    this.totalPages = data.value.totalPages;
                    this.totalResults = data.value.totalResults;
                }

                this.error = error.value;
                this.loading = isLoading.value;
            } catch (error) {
                console.error('[ERROR]:', error);
            }
        },
    },
});
